export const startsNewCaptionRun = (
  captions: string[],
  prevLength: number,
  prevFirst: string | null,
): boolean =>
  prevLength === 0 || captions.length < prevLength || captions[0] !== prevFirst;
